function LoadingIndicatorService() {
    this._isLoading = false;
    this._isMasked = false;
}

LoadingIndicatorService.prototype.isLoading = function (isLoading, isMasked) {
    if (isLoading !== undefined) {
        this._isLoading = isLoading;
    }

    if (isMasked !== undefined) {
        this._isMasked = isMasked;
    }

    return {
        isLoading: this._isLoading,
        isMasked: this._isMasked
    };
};

LoadingIndicatorService.prototype.startLoading = function (isMasked) {
    return this.isLoading(true, isMasked);
};

LoadingIndicatorService.prototype.finishLoading = function () {
    return this.isLoading(false, false);
};

module.exports = LoadingIndicatorService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/loadingindicator/loading-indicator-service.js
 **/